const areas = [
    { "id": 200, "pid": 0, "name": "成都市" },
    { "id": 201, "pid": 0, "name": "自贡市" },
    { "id": 202, "pid": 0, "name": "攀枝花市" },
    { "id": 203, "pid": 0, "name": "泸州市" },
    { "id": 204, "pid": 0, "name": "德阳市" },
    { "id": 205, "pid": 0, "name": "绵阳市" },
    { "id": 206, "pid": 0, "name": "广元市" },
    { "id": 207, "pid": 0, "name": "遂宁市" },
    { "id": 208, "pid": 0, "name": "内江市" },
    { "id": 209, "pid": 0, "name": "乐山市" },
    { "id": 210, "pid": 0, "name": "南充市" },
    { "id": 211, "pid": 0, "name": "眉山市" },
    { "id": 212, "pid": 0, "name": "宜宾市" },
    { "id": 213, "pid": 0, "name": "广安市" },
    { "id": 214, "pid": 0, "name": "达州市" },
    { "id": 215, "pid": 0, "name": "雅安市" },
    { "id": 216, "pid": 0, "name": "巴中市" },
    { "id": 217, "pid": 0, "name": "资阳市" },
    { "id": 218, "pid": 0, "name": "阿坝州" },
    { "id": 219, "pid": 0, "name": "甘孜州" },
    { "id": 220, "pid": 0, "name": "凉山州" },
    { "id": 300, "pid": 200, "name": "天府新区" },
    { "id": 301, "pid": 200, "name": "高新区" },
    { "id": 302, "pid": 200, "name": "锦江区" },
    { "id": 303, "pid": 200, "name": "青羊区" },
    { "id": 304, "pid": 200, "name": "金牛区" },
    { "id": 305, "pid": 200, "name": "武侯区" },
    { "id": 306, "pid": 200, "name": "成华区" },
    { "id": 307, "pid": 200, "name": "龙泉驿区" },
    { "id": 308, "pid": 200, "name": "青白江区" },
    { "id": 309, "pid": 200, "name": "新都区" },
    { "id": 310, "pid": 200, "name": "温江区" },
    { "id": 311, "pid": 200, "name": "金堂县" },
    { "id": 312, "pid": 200, "name": "双流区" },
    { "id": 313, "pid": 200, "name": "郫都区" },
    { "id": 314, "pid": 200, "name": "大邑县" },
    { "id": 315, "pid": 200, "name": "蒲江县" },
    { "id": 316, "pid": 200, "name": "新津区" },
    { "id": 317, "pid": 200, "name": "简阳市" },
    { "id": 318, "pid": 200, "name": "都江堰市" },
    { "id": 319, "pid": 200, "name": "彭州市" },
    { "id": 320, "pid": 200, "name": "邛崃市" },
    { "id": 321, "pid": 200, "name": "崇州市" },
    { "id": 322, "pid": 201, "name": "自流井区" },
    { "id": 323, "pid": 201, "name": "贡井区" },
    { "id": 324, "pid": 201, "name": "大安区" },
    { "id": 325, "pid": 201, "name": "沿滩区" },
    { "id": 326, "pid": 201, "name": "荣县" },
    { "id": 327, "pid": 201, "name": "富顺县" },
    { "id": 328, "pid": 202, "name": "东区" },
    { "id": 329, "pid": 202, "name": "西区" },
    { "id": 330, "pid": 202, "name": "仁和区" },
    { "id": 331, "pid": 202, "name": "米易县" },
    { "id": 332, "pid": 202, "name": "盐边县" },
    { "id": 333, "pid": 203, "name": "江阳区" },
    { "id": 334, "pid": 203, "name": "纳溪区" },
    { "id": 335, "pid": 203, "name": "龙马潭区" },
    { "id": 336, "pid": 203, "name": "泸县" },
    { "id": 337, "pid": 203, "name": "合江县" },
    { "id": 338, "pid": 203, "name": "叙永县" },
    { "id": 339, "pid": 203, "name": "古蔺县" },
    { "id": 340, "pid": 204, "name": "经开区（德阳市）" },
    { "id": 341, "pid": 204, "name": "旌阳区" },
    { "id": 342, "pid": 204, "name": "中江县" },
    { "id": 343, "pid": 204, "name": "罗江区" },
    { "id": 344, "pid": 204, "name": "广汉市" },
    { "id": 345, "pid": 204, "name": "什邡市" },
    { "id": 346, "pid": 204, "name": "绵竹市" },
    { "id": 347, "pid": 205, "name": "高新区（绵阳市）" },
    { "id": 348, "pid": 205, "name": "经开区（绵阳市）" },
    { "id": 349, "pid": 205, "name": "科技城科教创业园区（绵阳市）" },
    { "id": 350, "pid": 205, "name": "仙海区（绵阳市）" },
    { "id": 351, "pid": 205, "name": "涪城区" },
    { "id": 352, "pid": 205, "name": "游仙区" },
    { "id": 353, "pid": 205, "name": "三台县" },
    { "id": 354, "pid": 205, "name": "盐亭县" },
    { "id": 355, "pid": 205, "name": "安州区" },
    { "id": 356, "pid": 205, "name": "梓潼县" },
    { "id": 357, "pid": 205, "name": "北川县" },
    { "id": 358, "pid": 205, "name": "平武县" },
    { "id": 359, "pid": 205, "name": "江油市" },
    { "id": 361, "pid": 206, "name": "经开区（广元市）" },
    { "id": 362, "pid": 206, "name": "利州区" },
    { "id": 363, "pid": 206, "name": "昭化区" },
    { "id": 364, "pid": 206, "name": "朝天区" },
    { "id": 365, "pid": 206, "name": "旺苍县" },
    { "id": 366, "pid": 206, "name": "青川县" },
    { "id": 367, "pid": 206, "name": "剑阁县" },
    { "id": 368, "pid": 206, "name": "苍溪县" },
    { "id": 369, "pid": 207, "name": "船山区" },
    { "id": 370, "pid": 207, "name": "安居区" },
    { "id": 371, "pid": 207, "name": "蓬溪县" },
    { "id": 372, "pid": 207, "name": "射洪市" },
    { "id": 373, "pid": 207, "name": "大英县" },
    { "id": 374, "pid": 208, "name": "市中区" },
    { "id": 375, "pid": 208, "name": "东兴区" },
    { "id": 376, "pid": 208, "name": "威远县" },
    { "id": 377, "pid": 208, "name": "资中县" },
    { "id": 378, "pid": 208, "name": "隆昌市" },
    { "id": 379, "pid": 209, "name": "市中区" },
    { "id": 380, "pid": 209, "name": "沙湾区" },
    { "id": 381, "pid": 209, "name": "五通桥区" },
    { "id": 382, "pid": 209, "name": "金口河区" },
    { "id": 383, "pid": 209, "name": "犍为县" },
    { "id": 384, "pid": 209, "name": "井研县" },
    { "id": 385, "pid": 209, "name": "夹江县" },
    { "id": 386, "pid": 209, "name": "沐川县" },
    { "id": 387, "pid": 209, "name": "峨边县" },
    { "id": 388, "pid": 209, "name": "马边县" },
    { "id": 389, "pid": 210, "name": "顺庆区" },
    { "id": 390, "pid": 210, "name": "高坪区" },
    { "id": 391, "pid": 210, "name": "嘉陵区" },
    { "id": 392, "pid": 210, "name": "南部县" },
    { "id": 393, "pid": 210, "name": "营山县" },
    { "id": 394, "pid": 210, "name": "蓬安县" },
    { "id": 395, "pid": 210, "name": "仪陇县" },
    { "id": 396, "pid": 210, "name": "西充县" },
    { "id": 397, "pid": 210, "name": "阆中市" },
    { "id": 398, "pid": 211, "name": "东坡区" },
    { "id": 399, "pid": 211, "name": "彭山区" },
    { "id": 401, "pid": 211, "name": "仁寿县" },
    { "id": 402, "pid": 211, "name": "洪雅县" },
    { "id": 403, "pid": 211, "name": "丹棱县" },
    { "id": 404, "pid": 211, "name": "青神县" },
    { "id": 405, "pid": 212, "name": "翠屏区" },
    { "id": 407, "pid": 212, "name": "南溪区" },
    { "id": 408, "pid": 212, "name": "叙州区" },
    { "id": 409, "pid": 212, "name": "江安县" },
    { "id": 410, "pid": 212, "name": "长宁县" },
    { "id": 411, "pid": 212, "name": "高县" },
    { "id": 412, "pid": 212, "name": "珙县" },
    { "id": 413, "pid": 212, "name": "筠连县" },
    { "id": 414, "pid": 212, "name": "兴文县" },
    { "id": 415, "pid": 212, "name": "屏山县" },
    { "id": 416, "pid": 213, "name": "广安区" },
    { "id": 417, "pid": 213, "name": "前锋区" },
    { "id": 418, "pid": 213, "name": "岳池县" },
    { "id": 419, "pid": 213, "name": "武胜县" },
    { "id": 420, "pid": 213, "name": "邻水县" },
    { "id": 421, "pid": 213, "name": "华蓥市" },
    { "id": 422, "pid": 214, "name": "通川区" },
    { "id": 423, "pid": 214, "name": "达川区" },
    { "id": 425, "pid": 214, "name": "宣汉县" },
    { "id": 426, "pid": 214, "name": "开江县" },
    { "id": 427, "pid": 214, "name": "大竹县" },
    { "id": 428, "pid": 214, "name": "渠县" },
    { "id": 429, "pid": 214, "name": "万源市" },
    { "id": 430, "pid": 215, "name": "经开区（雅安市）" },
    { "id": 431, "pid": 215, "name": "雨城区" },
    { "id": 432, "pid": 215, "name": "名山区" },
    { "id": 433, "pid": 215, "name": "荥经县" },
    { "id": 434, "pid": 215, "name": "汉源县" },
    { "id": 435, "pid": 215, "name": "石棉县" },
    { "id": 436, "pid": 215, "name": "天全县" },
    { "id": 437, "pid": 215, "name": "芦山县" },
    { "id": 438, "pid": 215, "name": "宝兴县" },
    { "id": 439, "pid": 216, "name": "巴州区" },
    { "id": 440, "pid": 216, "name": "恩阳区" },
    { "id": 441, "pid": 216, "name": "通江县" },
    { "id": 442, "pid": 216, "name": "南江县" },
    { "id": 443, "pid": 216, "name": "平昌县" },
    { "id": 444, "pid": 217, "name": "雁江区" },
    { "id": 445, "pid": 217, "name": "安岳县" },
    { "id": 446, "pid": 217, "name": "乐至县" },
    { "id": 447, "pid": 218, "name": "汶川县" },
    { "id": 448, "pid": 218, "name": "理县" },
    { "id": 449, "pid": 218, "name": "茂县" },
    { "id": 450, "pid": 218, "name": "松潘县" },
    { "id": 451, "pid": 218, "name": "九寨沟县" },
    { "id": 452, "pid": 218, "name": "金川县" },
    { "id": 453, "pid": 218, "name": "小金县" },
    { "id": 454, "pid": 218, "name": "黑水县" },
    { "id": 455, "pid": 218, "name": "马尔康市" },
    { "id": 456, "pid": 218, "name": "壤塘县" },
    { "id": 457, "pid": 218, "name": "阿坝县" },
    { "id": 458, "pid": 218, "name": "若尔盖县" },
    { "id": 459, "pid": 218, "name": "红原县" },
    { "id": 460, "pid": 219, "name": "康定市" },
    { "id": 461, "pid": 219, "name": "泸定县" },
    { "id": 462, "pid": 219, "name": "丹巴县" },
    { "id": 463, "pid": 219, "name": "九龙县" },
    { "id": 464, "pid": 219, "name": "雅江县" },
    { "id": 465, "pid": 219, "name": "道孚县" },
    { "id": 466, "pid": 219, "name": "炉霍县" },
    { "id": 467, "pid": 219, "name": "甘孜县" },
    { "id": 468, "pid": 219, "name": "新龙县" },
    { "id": 469, "pid": 219, "name": "德格县" },
    { "id": 470, "pid": 219, "name": "白玉县" },
    { "id": 471, "pid": 219, "name": "石渠县" },
    { "id": 472, "pid": 219, "name": "色达县" },
    { "id": 473, "pid": 219, "name": "理塘县" },
    { "id": 474, "pid": 219, "name": "巴塘县" },
    { "id": 475, "pid": 219, "name": "乡城县" },
    { "id": 476, "pid": 219, "name": "稻城县" },
    { "id": 477, "pid": 219, "name": "得荣县" },
    { "id": 478, "pid": 219, "name": "海螺沟" },
    { "id": 479, "pid": 220, "name": "西昌市" },
    { "id": 480, "pid": 220, "name": "木里县" },
    { "id": 481, "pid": 220, "name": "盐源县" },
    { "id": 482, "pid": 220, "name": "德昌县" },
    { "id": 483, "pid": 220, "name": "会理县" },
    { "id": 484, "pid": 220, "name": "会东县" },
    { "id": 485, "pid": 220, "name": "宁南县" },
    { "id": 486, "pid": 220, "name": "普格县" },
    { "id": 487, "pid": 220, "name": "布拖县" },
    { "id": 488, "pid": 220, "name": "金阳县" },
    { "id": 489, "pid": 220, "name": "昭觉县" },
    { "id": 490, "pid": 220, "name": "喜德县" },
    { "id": 491, "pid": 220, "name": "冕宁县" },
    { "id": 492, "pid": 220, "name": "越西县" },
    { "id": 493, "pid": 220, "name": "甘洛县" },
    { "id": 494, "pid": 220, "name": "美姑县" },
    { "id": 495, "pid": 220, "name": "雷波县" },
    { "id": 496, "pid": 200, "name": "东部新区" },
    { "id": 497, "pid": 201, "name": "自贡市高新区" },
    { "id": 498, "pid": 204, "name": "德阳高新区" },
    { "id": 499, "pid": 207, "name": "遂宁经开区" },
    { "id": 500, "pid": 207, "name": "遂宁市河东新区" },
    { "id": 501, "pid": 207, "name": "遂宁高新区" },
    { "id": 502, "pid": 208, "name": "内江高新区" },
    { "id": 503, "pid": 208, "name": "内江经开区" },
    { "id": 504, "pid": 209, "name": "高新区(乐山)" },
    { "id": 505, "pid": 209, "name": "峨眉山景区管委会" },
    { "id": 506, "pid": 209, "name": "乐山大佛景区管委会" },
    { "id": 507, "pid": 209, "name": "峨眉山市" },

]

export default areas;

export function getAreaMap() {
    let map = {};
    areas.forEach(item => {
        map[item.id] = item;
    });
    return map
}

export function getAreaTree() {
    let data = areas.map(item => {
        return {
            "value": item.id,
            "text": item.name,
            "pid": item.pid,
            "id": item.id,
            "type": item.type
        }
    })
    let result = []
    if (!Array.isArray(data)) {
        return result
    }
    data.forEach(item => {
        delete item.children;
    });
    let map = {};
    data.forEach(item => {
        map[item.id] = item;
    });
    data.forEach(item => {
        let parent = map[item.pid];
        if (parent) {
            (parent.children || (parent.children = [])).push(item);
        } else {
            result.push(item);
        }
    });
    return result;
}